export default __webpack_public_path__ + "static/media/ico-investimento.7be94f07.svg";